export enum DocumentStatus {
  NEW = 'NEW',

  CHANGED = 'CHANGED',

  ARCHIVED = 'ARCHIVED',
}
